import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// HTML内のルート要素を取得
const rootElement = document.getElementById('root');

if (rootElement) {
  // ルート要素が存在する場合のみレンダリングを実行
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error("Failed to find the root element. Ensure there is a <div id='root'></div> in your index.html.");
}
